import { TSelectedRecommendedPackageId } from '../../../../types/reducers/recommendedPackages';
import { IAppState } from '../../../../../AppModulesWrapper';

export function selectSelectedRecommendedPackageId(state: IAppState): TSelectedRecommendedPackageId {
  return state.servicePickerWidgetV2.recommendedPackages.selectedPackageId;
}
